import { Component, OnDestroy, OnInit } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { AccessControlService } from "../../app/access-control/access-control-service";
import { AuthService } from "../../app/auth/auth.service";
import { StateManagementService } from "../../providers/state-management/state-management.service";
import { UsersService } from "../../providers/users-service/users.service";
import { BasePage } from "../base-page";

@IonicPage()
@Component({
  selector: "user-settings",
  templateUrl: "user-settings.html",
})
export class UserSettings extends BasePage implements OnDestroy, OnInit {
  titleSection: string = "User Settings";

  constructor(
    protected accessControlService: AccessControlService,
    protected navCtrl: NavController,
    protected navParams: NavParams,
    protected userService: UsersService,
    protected stateManagementService: StateManagementService,
    protected authSvc: AuthService
  ) {
    super(stateManagementService);
  }

  ionViewDidLoad() {
    this.stateManagementService.setSectionId("settings");
  }

  ionViewCanEnter() {
    return this.authSvc.authenticated();
  }

  navigate(entity: string) {
    this.navCtrl.push("MyAlertsPage");
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/pages/user-settings/user-settings.ts